import { render, staticRenderFns } from "./GlobalLeaderboard.vue?vue&type=template&id=135854aa&scoped=true"
import script from "./GlobalLeaderboard.vue?vue&type=script&lang=js"
export * from "./GlobalLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./GlobalLeaderboard.vue?vue&type=style&index=0&id=135854aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135854aa",
  null
  
)

export default component.exports